<template>
  <div id="tab1">
    <ValidationObserver ref="generalForm">
      <form name="generalForm" novalidate @submit.prevent="save">
        <div class="block-spacing-extended">
          <SectionTitle
            content="Información General"
            :has-line="true"
            class="mr-3"
          />
          <div class="row ml-2 mt-5">
            <div class="col-md-5 col-sm-12">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  id="ddlServiceCenter"
                  v-model="info.selectedServiceCenter"
                  required
                  :options="options.serviceCenter"
                  fieldkey="id"
                  fieldname="name"
                  label="CSEE que realiza el registro:"
                  label-class="custom-label"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="El Centro es requerido."
                  class="custom-dropdown"
                  :disabled="
                    isReadMode ||
                      !canEditTab1 ||
                      options.serviceCenter.length == 1
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-5 col-sm-12">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  id="ddlFoundProgram"
                  v-model="info.selectedMode"
                  required
                  :options="options.mode"
                  fieldkey="id"
                  fieldname="name"
                  label="Modo por el cual se enteró del programa de Educación Especial:"
                  label-class="custom-label"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :custom-error-msg="resources['17054']"
                  class="custom-dropdown"
                  :disabled="isReadMode || !canEditTab1 || isHealthDeptReadOnly"
                  @input="onChangeMode"
                />
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="isAllowedCenterForDigitalSignature"
            class="d-flex flex-column flex-md-row justify-content-between ml-2 mr-3 mt-4 mb-5 signature-wrapper"
          >
            <div>
              <span class="mt-3 mr-2 font-16">
                Mecanismo de firma para los formularios relacionados al proceso
                de registro
              </span>
            </div>
            <div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  v-model="info.digitalSignatureFlag"
                  :change-event="
                    item => {
                      onChangeDigitalSignatureFlag(item);
                    }
                  "
                  class="custom-radio__extended"
                  container-class="custom-radio-center"
                  custom-error-msg="Favor marcar si es digital o manuscrito."
                  :error="Boolean(errors[0])"
                  is-question-list
                  name="signatureCheck"
                  :options="signatureOptions"
                  :disabled="isReadMode || !canEditTab1"
                />
              </validation-provider>
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-md-3 col-sm-12 mt-3">
              <strong class="d-block">Año Académico:</strong>
              <span id="spRegistryAcademicYear">{{ info.academicYear }}</span>
            </div>
            <div class="col-md-3 mt-sm-12 mt-3">
              <div class="text-box">
                <strong class="d-block">Número:</strong>
                <span id="spRegistryNumber">{{ info.number }}</span>
              </div>
            </div>
            <div class="col-md-3 col-sm-12 mt-3">
              <div class="text-box">
                <strong class="d-block">Estatus:</strong>
                <span id="spRegistryStatus">{{ info.status }}</span>
              </div>
            </div>
          </div>
          <ValidationObserver ref="datesForm">
            <form name="datesForm" novalidate @submit.prevent="registerStudent">
              <div class="row ml-2 mt-4">
                <div class="col-md-3 col-sm-12 mt-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="referralDate"
                  >
                    <CustomDatePicker
                      id="dpReferralDate"
                      v-model="info.referralDate"
                      label="Referido:"
                      :placeholder="'DD/MM/YYYY'"
                      :error="errors[0]"
                      :custom-error-msg="resources['17000']"
                      :max-date="new Date()"
                      class="w-35"
                      :disabled="
                        isReadMode || !canEditTab1 || isReferralDateReadOnly
                      "
                    />
                  </ValidationProvider>
                </div>
                <div
                  v-if="info.status != StudentStatuses.Disponible"
                  class="col-md-3 col-sm-12 mt-3"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|greaterThanReferralDate:@referralDate"
                    name="consentmentDate"
                  >
                    <CustomDatePicker
                      id="dpEvaluationConsentmentDate"
                      v-model="info.evaluationConsentmentDate"
                      label="Consentimiento Evaluación:"
                      :placeholder="'DD/MM/YYYY'"
                      :error="errors[0]"
                      :custom-error-msg="errors[0]"
                      :max-date="new Date()"
                      class="w-35"
                      :disabled="isReadMode || !canEditTab1"
                    />
                  </ValidationProvider>
                </div>
                <div
                  v-if="info.status != StudentStatuses.Disponible"
                  class="col-md-3 col-sm-12 mt-3"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|greaterThanReferralDate:@referralDate|greaterThanConsentimentDate:@consentmentDate"
                    name="registrationDate"
                  >
                    <CustomDatePicker
                      id="dpRegistrationDate"
                      v-model="info.registrationDate"
                      label="Registro:"
                      :placeholder="'DD/MM/YYYY'"
                      :error="errors[0]"
                      :custom-error-msg="errors[0]"
                      :max-date="new Date()"
                      class="w-35"
                      :disabled="isReadMode || !canEditTab1"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-3 col-sm-12 mt-3" v-if="canViewGrage">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      id="ddlSelectedGrade"
                      v-model="info.selectedGrade"
                      :options="options.grade"
                      fieldkey="id"
                      fieldname="name"
                      label="Grado:"
                      placeholder="Seleccione"
                      :custom-error-msg="errors[0]"
                      :error="errors[0]"
                      :disabled="disableGrade"
                      placement-top
                    />
                  </ValidationProvider>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
        <div
          v-if="info.status == StudentStatuses.PreRegistro"
          class="block-spacing-extended"
        >
          <SectionTitle
            content="Creación y Modificación"
            :has-line="true"
            class="mr-3"
          />
          <div class="row ml-2">
            <div class="col">
              <strong class="d-block">Creado:</strong>
              <span id="spCreatedDate">{{ info.createdDate }}</span>
              <br />
              <span id="spCreatedBy">{{ info.createdBy }}</span>
              <br />
            </div>
            <div class="col">
              <div class="text-box">
                <strong class="d-block">Modificado:</strong>
                <span id="spModifyDate">{{ info.modifyDate }}</span>
                <br />
                <span id="spModifyBy">{{ info.modifyBy }}</span>
                <br />
              </div>
            </div>
            <div class="col" />
          </div>
        </div>
        <div class="block-spacing">
          <SectionTitle
            content="Información de Ubicación al Momento de Registro"
            :has-line="true"
            class="mr-3"
          />
          <div class="row ml-2">
            <div class="col-md-4 col-sm-12 mt-3">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="registrationPlace"
              >
                <CustomDropDown
                  id="ddlSelectedPlace"
                  v-model="info.selectedPlace"
                  required
                  :options="options.place"
                  fieldkey="id"
                  fieldname="name"
                  label="Lugar:"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :custom-error-msg="resources['17002']"
                  :disabled="
                    isPlaceUbicationDisabled(info.selectedPlace) ||
                      isHealthDeptReadOnly
                  "
                  placement-top
                  @input="onChangePlace"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`${this.isRequiredCustomValidator ? 'required' : ''}`"
              >
                <CustomDropDown
                  id="ddlSelectedType"
                  v-model="info.selectedType"
                  :options="options.type"
                  fieldkey="id"
                  fieldname="name"
                  label="Tipo:"
                  placeholder="Seleccione"
                  :custom-error-msg="resources['17003']"
                  :error="errors[0]"
                  :disabled="isTypeUbicationDisabled(info.selectedType)"
                  placement-top
                  @input="onChangeType"
                />
              </ValidationProvider>
            </div>
            <div v-if="showHealthDeptReferral" class="col-md-4 col-sm-12 mt-3">
              <div class="custom-control custom-checkbox checkbox-top-spacing">
                <input
                  id="chkhelthDeptReferralText"
                  v-model="info.isHealthDeptReferral"
                  :disabled="isHealthDeptReadOnly"
                  type="checkbox"
                  name="chkhelthDeptReferralText"
                  class="custom-control-input"
                />
                <label
                  for="chkhelthDeptReferralText"
                  class="custom-control-label font regular"
                >
                  <span><em class="ic-check"/></span>
                  {{ helthDeptReferralText }}
                </label>
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-2">
            <div class="col-md-4 col-sm-12 mt-3">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`${this.isRequiredCustomValidator ? 'required' : ''}`"
              >
                <CustomDropDown
                  id="ddlSelectedRegion"
                  v-model="info.selectedRegion"
                  :options="options.region"
                  fieldkey="id"
                  fieldname="name"
                  label="Región:"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :custom-error-msg="resources['17004']"
                  :disabled="isReadMode || !canEditTab1"
                  placement-top
                  @input="onChangeRegion"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`${this.isRequiredCustomValidator ? 'required' : ''}`"
              >
                <CustomDropDown
                  id="ddlSelectedDistrict"
                  v-model="info.selectedDistrict"
                  :options="options.district"
                  fieldkey="id"
                  fieldname="name"
                  label="Distrito:"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :custom-error-msg="resources['17005']"
                  :disabled="isReadMode || !canEditTab1"
                  placement-top
                  @input="onChangeDistrict"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`${this.isRequiredCustomValidator ? 'required' : ''}`"
              >
                <CustomDropDown
                  id="ddlSelectedSchool"
                  v-model="info.selectedSchool"
                  :options="options.school"
                  fieldkey="id"
                  fieldname="name"
                  label="Escuela:"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  :custom-error-msg="resources['17006']"
                  :disabled="isReadMode || !canEditTab1"
                  placement-top
                  @input="onChangeSchool"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <FixedBottomSaveButton
      v-if="saveButtonVisibility && canEditTab1"
      :offset="200"
      @click="save"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import FixedBottomSaveButton from "@/components/common/FixedBottomSaveButton";
import { ValidationObserver, extend } from "vee-validate";
import { CustomDropDown, CustomDatePicker } from "@/components/common";
import { SectionTitle } from "@/components/pei/shared/";
import CustomRadio from "custom-radio";
import store from "@/store/index";
import alert from "@/mixin/alert.mixin";
import loading from "@/mixin/loading.mixin";
import resourcesService from "@/services/resources.js";
import UserLocationTypes from "@/utils/constants/student/UserLocationTypes";
import StudentStatuses from "@/utils/constants/reg/studentStatuses.js";
import SchoolTypes from "@/utils/constants/student/schoolTypes";
const { mapState, mapMutations } = createNamespacedHelpers("$_student");
import academicService from "@/services/api/academicUtils.api.js";

extend("greaterThanReferralDate", {
  params: ["target"],
  message: () =>
    "Favor de seleccionar una fecha mayor o igual a la fecha de referido. (17048)",
  validate(value, { target }) {
    return value.setHours(0, 0, 0, 0) >= target.setHours(0, 0, 0, 0);
  }
});

extend("greaterThanConsentimentDate", {
  params: ["target"],
  message: () =>
    "La fecha de Registro no puede ser menor a la fecha de Consentimiento de Evaluación.",
  validate(value, { target }) {
    return value.setHours(0, 0, 0, 0) >= target.setHours(0, 0, 0, 0);
  }
});

const _ReferralFromAnotherAgencyIdentifier = 397;
const _HealthDeptIdentifier = 254;

export default {
  name: "Tab1",
  mixins: [alert, loading],
  components: {
    FixedBottomSaveButton,
    ValidationObserver,
    CustomDropDown,
    CustomDatePicker,
    SectionTitle,
    CustomRadio
  },
  data() {
    return {
      messages: {
        requiredFields: "Campo requerido.",
        requiredDate: "Fecha requerido."
      },
      options: {
        mode: [],
        place: [],
        type: [],
        region: [],
        district: [],
        school: [],
        serviceCenter: [],
        grade: []
      },
      info: {
        regStudentId: null,
        hasActiveSIE: false,
        selectedMode: null,
        selectedServiceCenter: null,
        academicYear: null,
        academicYearId: null,
        number: null,
        status: null,
        referralDate: null,
        evaluationConsentmentDate: null,
        registrationDate: null,
        selectedPlace: null,
        selectedType: null,
        selectedGrade: null,
        selectedRegion: null,
        selectedDistrict: null,
        selectedSchool: null,
        locationOrigin: null,
        locationType: null,
        locationRegionId: null,
        locationDistrictId: null,
        locationId: null,
        mediaKnowAboutProgramId: null,
        isHealthDeptReferral: null,
        studentAge: null,
        createdBy: null,
        createdDate: null,
        modifyBy: null,
        modifyDate: null,
        digitalSignatureFlag: null
      },
      signatureOptions: [
        {
          value: true,
          label: "PAD DIGITAL",
          check: false
        },
        {
          value: false,
          label: "MANUSCRITO",
          check: false
        }
      ],
      AllowedCenterForDigitalSignature: false,
      student: Object,
      resources: [],
      savePreRegistry: false,
      helthDeptReferralText: "Referido Departamento de Salud",
      isHealthDeptReferral: false,
      oldInfo: {
        isHealthDeptReferral: null,
        referralDate: null
      },
      evaluationConsentmentDateValidation: null,
      registrationDateValidation: null,
      canEditTab1: store.getters.HasPermission("registry.editTab1")
    };
  },
  computed: {
    ...mapState([
      "isStudentRegistryPropagation",
      "studentPreRegistryValidations",
      "selectedStudentPreRegistry"
    ]),
    isReadMode() {
      return this.selectedStudentPreRegistry.isReadMode;
    },
    canViewGrage() {
      return this.canRegister || this.info.selectedGrade;
    },
    StudentStatuses() {
      return StudentStatuses;
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    canRegister() {
      return (
        this.studentStatus === StudentStatuses.PreRegistro ||
        this.studentStatus === StudentStatuses.Disponible
      );
    },
    saveButtonVisibility() {
      return this.canRegister;
    },
    isRequiredCustomValidator() {
      if (this.canRegister) {
        //Departamento de Salud
        if (
          this.info.selectedPlaceId != null &&
          this.info.selectedPlaceId == 254
        ) {
          if (this.savePreRegistry) {
            return true;
          } else {
            return false;
          }
        }
      }
      return true;
    },
    showHealthDeptReferral() {
      const place = this.info.selectedPlace || {};
      return (
        this.oldInfo.isHealthDeptReferral ||
        place.id === UserLocationTypes.HealthDept ||
        (place.id === UserLocationTypes.PublicSchool &&
          this.hasToggleHealthDeptPermission)
      );
    },
    canEditHealthDept() {
      return (
        this.studentStatus === StudentStatuses.PreRegistro ||
        this.studentStatus === StudentStatuses.Registro ||
        this.studentStatus === StudentStatuses.Disponible
      );
    },
    isAllowedCenterForDigitalSignature() {
      return (
        this.AllowedCenterForDigitalSignature &&
        store.getters.HasPermission("eduesp.preregister.digitalsignatureaccess")
      );
    },
    isHealthDeptReadOnly() {
      return (
        (this.showHealthDeptReferral &&
          this.oldInfo.isHealthDeptReferral &&
          !this.hasToggleHealthDeptPermission) ||
        !this.canEditHealthDept ||
        this.info.pcStudentId > 0
      );
    },
    isReferralDateReadOnly() {
      return this.oldInfo.referralDate !== null;
    },
    hasToggleHealthDeptPermission() {
      return store.getters.HasPermission("menu.cantogglehealthflag");
    },
    userServiceCenters() {
      return store.getters["$_user/serviceCenters"] || [];
    },
    hasHealthDeptReferralFlagAndType() {
      return (
        this.info?.isHealthDeptReferral &&
        this.info?.selectedPlaceId === UserLocationTypes.HealthDept
      );
    },
    disableGrade() {
      if (this.canRegister) return false;
      return this.isReadMode || !this.canEditTab1
    }
  },
  watch: {
    isStudentRegistryPropagation(dataChanged) {
      if (dataChanged.value === true) {
        this.registerStudent();
      }
    },
    async "info.selectedServiceCenter"(value) {
      if (value != null) {
        this.AllowedCenterForDigitalSignature = await this.isAllowed(value.id);
        if (!this.AllowedCenterForDigitalSignature)
          this.info.digitalSignatureFlag = false;
      }
    }
  },
  activated() {
    // this methods are for sending the save method and the discardChanges
    // when this tab is activated (being the tab displayed)
    this.$store.commit("setSaveMethod", this.save);
    this.$store.commit("setResetOriginalDataMethod", this.discardChanges);
    if (this.studentStatus == StudentStatuses.PreRegistro)
      this.$emit("set-button-save-visibility", true);
  },
  methods: {
    ...mapMutations([
      "setStudentPreRegistry",
      "setSelectedStudentStatus",
      "setStudentPreRegistryValidations"
    ]),
    //TODO: data info, no renderiza correctamente en virtual dom.
    isPlaceUbicationDisabled(selectedPlace) {
      let isPublic = false;

      if (selectedPlace != null)
        isPublic =
          this.info.hasActiveSIE &&
          selectedPlace.id == UserLocationTypes.PublicSchool;

      return this.isReadMode || !this.canEditTab1 || isPublic;
    },
    isTypeUbicationDisabled(selectedType) {
      let isPublic = false;

      if (selectedType != null)
        isPublic =
          this.info.hasActiveSIE && selectedType.id == SchoolTypes.PublicSchool;

      return this.isReadMode || !this.canEditTab1 || isPublic;
    },
    async GetGeneralInfo() {
      await this.$ApiGet(
        "api/studentregistry/generalinfo?studentsie=" +
          store.getters.SelectedStudent.studentId
      )
        .then(res => {
          this.info = res.data;
          this.info.referralDate = res.data.referralDate
            ? new Date(res.data.referralDate)
            : null;
          this.info.createdDate = this.$formatDate(res.data.createdDate);
          this.info.modifyDate = res.data.modifyDate
            ? this.$formatDate(res.data.modifyDate)
            : null;
          this.info.evaluationConsentmentDate = res.data
            .evaluationConsentmentDate
            ? new Date(res.data.evaluationConsentmentDate)
            : null;
          this.info.registrationDate = res.data.registrationDate
            ? new Date(res.data.registrationDate)
            : null;

          this.info.selectedGrade = this.options.grade.find(
            x => x.id == this.info.selectedGradeId
          );

          this.oldInfo.isHealthDeptReferral = this.info.isHealthDeptReferral;
          this.oldInfo.referralDate = this.info.referralDate;

          this.getOrigins();
          store.getters[
            "$_student/getStudentPreRegistry"
          ].hasInitialEvaluationFlag = res.data.hasInitialEvaluationFlag
            ? "1"
            : "0";

          if (this.info.status === StudentStatuses.Registro) {
            if (this.info.digitalSignatureFlag) this.goToSignatureTab();
            else this.goToAppointmentTab();
          }

          if (this.info.status != StudentStatuses.Disponible) {
            this.info.selectedMode = res.data.selectedModeId
              ? this.options.mode.find(x => x.id == res.data.selectedModeId)
              : null;
          }

          if (this.info.selectedSchoolId) {
            this.info.selectedSchool = this.options.school.find(
              x => x.id == this.info.selectedSchoolId
            );

            if (
              this.options.serviceCenter.length == 1 &&
              !this.info.selectedServiceCenter
            ) {
              this.info.selectedServiceCenter = this.userServiceCenters[0];
            }
          } else if (this.options.serviceCenter.length == 1) {
            this.info.selectedServiceCenter = this.userServiceCenters[0];
          }

          if (this.info.digitalSignatureFlag != null) {
            this.info.digitalSignatureFlag = res.data.digitalSignatureFlag;

            let itemIndex = null;
            if (this.info.digitalSignatureFlag) {
              itemIndex = this.signatureOptions.findIndex(x => x.value);
              this.$emit("set-visibility", [7]);
            } else {
              itemIndex = this.signatureOptions.findIndex(x => !x.value);
            }
            const item = this.signatureOptions[itemIndex];
            item.check = true;
            this.signatureOptions[itemIndex] = item;
          }

          if (this.info.selectedServiceCenterId) {
            this.info.selectedServiceCenter = this.options.serviceCenter.find(
              x => x.id == this.info.selectedServiceCenterId
            );

            if (
              this.options.serviceCenter.length == 1 &&
              !this.info.selectedServiceCenter
            ) {
              this.info.selectedServiceCenter = this.userServiceCenters[0];
            }
          } else if (this.options.serviceCenter.length == 1) {
            this.info.selectedServiceCenter = this.userServiceCenters[0];
          }

          if (this.info.digitalSignatureFlag != null) {
            this.info.digitalSignatureFlag = res.data.digitalSignatureFlag;

            let itemIndex = null;
            if (this.info.digitalSignatureFlag) {
              itemIndex = this.signatureOptions.findIndex(x => x.value);
              this.$emit("set-visibility", [7]);
            } else {
              itemIndex = this.signatureOptions.findIndex(x => !x.value);
            }
            const item = this.signatureOptions[itemIndex];
            item.check = true;
            this.signatureOptions[itemIndex] = item;
          }

          this.setSelectedStudentStatus(this.info.status);

          if (this.isHealthDeptReadOnly) {
            this.info.selectedMode = this.options.mode.find(
              x => x.id === _ReferralFromAnotherAgencyIdentifier
            );
          }
        })
        .catch(err => {
          this.response = err;
        });
    },
    async getMediaknowaboutspecialeducationList() {
      let self = this;
      self
        .$ApiGet("api/code/geteduespcodes?codeType=6")
        .then(response => {
          self.options.mode = response.data;
        })
        .catch(errm => {
          self.ShowToast(errm.message, "", "error");
        });
    },
    async getServiceCenterList() {
      let self = this;

      if (this.userServiceCenters.length > 0) {
        self.options.serviceCenter = this.userServiceCenters;
      } else {
        self
          .$ApiGet("api/code/servicecenter")
          .then(response => {
            self.options.serviceCenter = response.data;
          })
          .catch(errm => {
            self.ShowToast(errm.message, "", "error");
          });
      }
    },
    async getGrades() {
      const { data } = await academicService.getGrades();
      this.options.grade = data;

      this.info.selectedGrade = this.options.grade.find(
        x => x.id == this.info.selectedGradeId
      );
    },
    async isAllowed(centerId) {
      let self = this;
      let result = false;

      try {
        result = (
          await self.$ApiGet(`api/signature/allowdigitalsignature/${centerId}`)
        ).data;
      } catch (errm) {
        self.ShowToast(errm.message, "", "error");
      }
      return result;
    },
    async getOrigins() {
      return await this.$ApiGet("/api/schools/userlocationtypes")
        .then(res => {
          this.options.place = res.data;

          if (this.info.status == StudentStatuses.Disponible) {
            if (this.info.hasActiveSIE) {
              this.info.selectedPlace = this.options.place.find(
                x => x.id == UserLocationTypes.PublicSchool
              ); //Escuelas Publicas
            }
          } else {
            this.info.selectedPlace = this.info.selectedPlaceId
              ? this.options.place.find(x => x.id == this.info.selectedPlaceId)
              : null;

            if (this.info.selectedPlaceId == UserLocationTypes.HealthDept) {
              this.isHealthDeptReferral = true;
            }
          }

          if (this.info.selectedPlaceId == null) {
            if (this.info.selectedPlace != null)
              this.info.selectedPlaceId = this.info.selectedPlace.id;
          }

          if (this.isHealthDeptReadOnly) {
            this.info.selectedPlace = this.options.place.find(
              x => x.id === _HealthDeptIdentifier
            );
          }

          this.getLocationTypes(this.info.selectedPlaceId);
        })
        .catch(err => {
          this.response = err;
        });
    },
    async getLocationTypes(selectedPlaceId) {
      await this.$ApiGet(
        "/api/schools/studentlocationtypes?locationTypes=" + selectedPlaceId
      )
        .then(res => {
          this.options.type = res.data;
          this.info.selectedType = this.options.type.find(
            x => x.id == this.info.selectedTypeId
          );

          if (!this.info.selectedType && this.options.type.length == 1) {
            this.info.selectedType = this.options.type[0];
          }

          if (this.info.selectedType) {
            this.getRegions();
          }
        })
        .catch(err => {
          this.response = err;
        });
    },
    async getRegions() {
      if (this.info.selectedType) {
        await this.$ApiGet(
          "/api/schools/types/regions?academicYear=" +
            this.info.academicYearId +
            "&schoolTypes=" +
            this.info.selectedType.id +
            "&schoolId=" +
            this.info.selectedSchoolId
        )
          .then(res => {
            this.options.region = res.data;

            if (this.status != StudentStatuses.Disponible) {
              this.info.selectedRegion = this.info.selectedRegionId
                ? this.options.region.find(
                    x => x.id == this.info.selectedRegionId
                  )
                : null;
              this.getDistricts();
            }

            if (!this.info.selectedRegion && this.options.region.length == 1) {
              this.info.selectedRegion = this.options.region[0];
              this.getDistricts();
            }
          })
          .catch(err => {
            this.response = err;
          });
      }
    },
    async getDistricts() {
      if (this.info.selectedRegion) {
        await this.$ApiGet(
          "/api/schools/types/regions/districts?regionId=" +
            this.info.selectedRegion.id +
            "&academicYear=" +
            this.info.academicYearId +
            "&schoolTypes=" +
            this.info.selectedType.id +
            "&schoolId=" +
            this.info.selectedSchoolId
        )
          .then(res => {
            this.options.district = res.data;
            if (this.status != StudentStatuses.Disponible) {
              this.info.selectedDistrict = this.info.selectedDistrictId
                ? this.options.district.find(
                    x => x.id == this.info.selectedDistrictId
                  )
                : null;
              this.getSchools();
            }

            if (
              !this.info.selectedDistrict &&
              this.options.district.length == 1
            ) {
              this.info.selectedDistrict = this.options.district[0];
              this.getSchools();
            }
          })
          .catch(err => {
            this.response = err;
          });
      }
    },
    async getSchools() {
      if (this.info.selectedDistrict) {
        await this.$ApiGet(
          "/api/schools?districtId=" +
            this.info.selectedDistrict.id +
            "&schoolTypes=" +
            this.info.selectedType.id +
            "&academicYear=" +
            this.info.academicYearId +
            "&schoolId=" +
            this.info.selectedSchoolId
        )
          .then(res => {
            this.options.school = res.data;
            if (this.status != StudentStatuses.Disponible) {
              this.info.selectedSchool = this.info.selectedSchoolId
                ? this.options.school.find(
                    x => x.id == this.info.selectedSchoolId
                  )
                : null;
            }

            if (!this.info.selectedSchool && this.options.school.length == 1) {
              this.info.selectedSchool = this.options.school[0];
            }
          })
          .catch(err => {
            this.response = err;
          });
      }
    },
    onChangeMode() {},
    async onChangePlace({ ...item }) {
      if (item.id) {
        this.isHealthDeptReferral = item.id == UserLocationTypes.HealthDept;
        await this.getLocationTypes(this.info.selectedPlace.id);
      }

      this.info.selectedPlaceId = item.id;
      this.options.region = [];
      this.info.selectedRegion = null;
      this.options.district = [];
      this.info.selectedDistrict = null;
      this.options.school = [];
      this.info.selectedSchool = null;
      this.getRegions();
      this.getDistricts();
      this.getSchools();
    },
    onChangeType({ ...item }) {
      if (item.id) {
        this.getRegions();
      }
      if (!item.id) {
        this.info.selectedPlace = null;
      }

      this.options.district = [];
      this.info.selectedDistrict = null;
      this.options.school = [];
      this.info.selectedSchool = null;
      this.getDistricts();
      this.getSchools();
    },
    onChangeRegion({ ...item }) {
      if (item.id) {
        this.getDistricts(this.info.selectedRegion.id);
      } else {
        this.info.selectedRegion = null;
        this.getRegions();
      }

      this.options.school = [];
      this.info.selectedSchool = null;
    },
    onChangeDistrict({ ...item }) {
      if (item.id) {
        this.getSchools(this.info.selectedDistrict.id);
      } else {
        this.info.selectedDistrict = null;
      }
      this.info.selectedSchool = null;
    },
    onChangeSchool() {},
    async save() {
      this.savePreRegistry = false;

      let isFormValid = await this.$refs.generalForm.validate();

      if (isFormValid) {
        if (this.info.status == StudentStatuses.Disponible) {
          const response = await alert.methods.ShowCancelModal(
            "Atención",
            "¿Está seguro que desea crear el Pre-Registro del estudiante?",
            "Sí",
            "No"
          );
          if (response) {
            await this.preRegisterStudent();
          }
        } else if (this.info.status == StudentStatuses.PreRegistro) {
          // Accion de actualizar pre-registro
          if (
            this.info.isHealthDeptReferral ||
            !this.info.isHealthDeptReferral
          ) {
            await this.updateRegStudent();
          } else {
            this.ShowToast("Error", this.resources["17055"], "error");
          }
        }
      }
    },
    setPayload() {
      this.info.mediaKnowAboutProgramId = this.info.selectedMode
        ? this.info.selectedMode.id
        : null;
      this.info.serviceCenterId = this.info.selectedServiceCenter
        ? this.info.selectedServiceCenter.id
        : null;
      this.info.locationOrigin = this.info.selectedPlace
        ? this.info.selectedPlace.id
        : null;
      this.info.locationType = this.info.selectedType
        ? this.info.selectedType.id
        : null;
      this.info.locationRegionId = this.info.selectedRegion
        ? this.info.selectedRegion.id
        : null;
      this.info.locationDistrictId = this.info.selectedDistrict
        ? this.info.selectedDistrict.id
        : null;
      this.info.locationId = this.info.selectedSchool
        ? this.info.selectedSchool.id
        : null;
      this.info.gradeId = this.info.selectedGrade
        ? this.info.selectedGrade.id
        : null;
    },
    async preRegisterStudent() {
      this.setPayload();
      await this.$ApiPost("/api/studentregistry/preregister", this.info)
        .then(async res => {
          if (res && res.data) {
            //update studentPreRegistry state
            this.setStudentPreRegistry({
              ...this.$store.state.$_student.selectedStudentPreRegistry,
              ...res.data
            });

            await this.$store.commit(
              "$_student/SetRegStudentId",
              res.data.regStudentId
            );

            //load general info
            await this.GetGeneralInfo();

            //show success toaster
            this.ShowToast(
              "Notificación",
              "Los datos fueron guardados exitosamente.",
              "success"
            );

            //show/move next tabs
            this.enableFollowingTabs();
            //this.goToProceduralGuarateesTab();
          }
        })
        .catch(err => {
          this.ShowToast(err.message, this.resources["R03200108"], "error");
        });
    },
    async updateRegStudent() {
      let self = this;

      self.setPayload();

      let promise = await new Promise(resolve => {
        self
          .$ApiPut("/api/studentregistry/updateregstudent", this.info)
          .then(response => {
            if (response && response.status === 200) {
              // Update studentPreRegistry state.
              this.setStudentPreRegistry({
                ...this.$store.state.$_student.selectedStudentPreRegistry,
                ...response.data
              });
              // Show success toaster.
              this.ShowToast(
                "Notificación",
                "Los datos fueron guardados exitosamente.",
                "success"
              );
              resolve(response);

              this.$emit("set-visibility", [7], false);
              if (this.info.digitalSignatureFlag)
                this.$emit("set-visibility", [7]);
            }
          })
          .catch(function(err) {
            this.ShowToast(err.message, this.resources["R03200108"], "error");
          });
      });

      return promise;
    },
    onChangeDigitalSignatureFlag(item) {
      this.info.digitalSignatureFlag = item.value;
    },
    parseTab(arr) {
      return arr
        .map(x => {
          const n = parseInt(x.id.split("").splice(x.id.length - 1)[0]);
          return {
            number: n,
            value: x.value
          };
        })
        .filter(x => x.value == false)
        .map(x => x.number);
    },
    async registerStudent() {
      this.savePreRegistry = false;
      if (this.canRegister) {
        this.savePreRegistry = true;
      }

      let areDatesValid = await this.$refs.datesForm.validate();
      let isFormValid = await this.$refs.generalForm.validate();

      // Show warning for tab 1
      if (
        (!isFormValid || !areDatesValid) &&
        this.isStudentRegistryPropagation.validateTab1 == true
      ) {
        const _numbers = [1, ...this.studentPreRegistryValidations];
        this.setInvalidTabs(_numbers, true);
      }

      if (isFormValid) {
        this.setPayload();
        await this.$ApiPost("/api/studentregistry/register", this.info)
          .then(({ data }) => {
            if (data) {
              const _areAllCompleted =
                data.filter(x => x.value == false).length == 0;

              if (_areAllCompleted) {
                // Update studentPreRegistry state
                this.$store.commit(
                  "$_student/SetRegStudentId",
                  this.info.regStudentId
                );

                this.GetGeneralInfo();
                // Show success toaster

                let hasInitialEvaluationFlag =
                  store.getters["$_student/getStudentPreRegistry"]
                    .hasInitialEvaluationFlag;

                if (hasInitialEvaluationFlag == "1") {
                  this.ShowToast(
                    "Notificación",
                    this.resources["5398001"],
                    "success"
                  );
                  this.enablePostRegistryTab();
                  this.goToPostRegistryTab();
                } else {
                  this.ShowToast(
                    "Notificación",
                    this.resources["5398002"],
                    "success"
                  );
                  this.enableAppointmentTab();
                  if (this.info.digitalSignatureFlag) this.goToSignatureTab();
                  else this.goToAppointmentTab();
                }
                this.setStudentPreRegistry({
                  ...this.$store.state.$_student.selectedStudentPreRegistry,
                  isReadMode: true
                });
              } else {
                const _parsedTab = this.parseTab(data);
                if (_parsedTab.length > 0) {
                  this.validateState(_parsedTab);
                  this.setStudentPreRegistryValidations(_parsedTab);

                  if (
                    (!isFormValid || !areDatesValid) &&
                    this.isStudentRegistryPropagation.validateTab1 == true
                  ) {
                    _parsedTab.push(1);
                  }
                  this.setInvalidTabs(_parsedTab, true);

                  let evaluationsTab = _parsedTab.find(x => x == 4);
                  if (evaluationsTab) {
                    this.ShowToast(
                      "Error",
                      this.resources["22122"],
                      this.toastType.Error
                    );
                  } else {
                    this.ShowToast(
                      "",
                      this.resources["R03200160"],
                      this.toastType.Error
                    );
                  }
                }
              }
            }
          })
          .catch(function(err) {
            this.ShowToast(
              err.message,
              this.resources["R03200108"],
              this.toastType.Error
            );
          });
      }
    },
    discardChanges() {
      // here goes the discard changes method for setting the data to the default values or value stored in db
      // this method is for being called when the user doesn't want the new changes to be applied when
      // leaving this tab.
    },
    async loadResources() {
      let resourceCodes = [
        "17000",
        "17001",
        "17002",
        "17003",
        "17004",
        "17005",
        "17006",
        "17007",
        "17008",
        "17047",
        "17048",
        "17053",
        "17054",
        "17055",
        "17056",
        "22122",
        "R03200108",
        "R03200160",
        "22053",
        "5398001",
        "5398002"
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    enableFollowingTabs() {
      this.$emit("set-visibility", [2, 3, 4]);
    },
    enablePostRegistryTab() {
      this.$emit("set-visibility", [6]);
    },
    enableAppointmentTab() {
      this.$emit("set-visibility", [5]);
    },
    goToAppointmentTab() {
      this.$emit("select-tab", 5);
    },
    goToPostRegistryTab() {
      this.$emit("select-tab", 6);
    },
    goToProceduralGuarateesTab() {
      this.$emit("select-tab", 2);
    },
    goToSignatureTab() {
      this.$emit("select-tab", 7);
    },
    setInvalidTabs(tabNumbers) {
      this.$emit("set-invalid-tabs", tabNumbers, true);
    },
    async validateState(tabNumbers) {
      const isValid = await this.$refs.datesForm.validate();
      if (!isValid) {
        //this.setInvalidTabs(tabNumbers, [...1])
      } else {
        this.setInvalidTabs(tabNumbers);
      }
    }
  },
  async mounted() {
    await this.getMediaknowaboutspecialeducationList();
    await this.getServiceCenterList();
    await this.loadResources();
    await this.GetGeneralInfo();
    await this.getGrades();

    if (store.getters.SelectedStudent.status == StudentStatuses.Disponible) {
      await this.getOrigins();
    }
  }
};
</script>

<style scoped lang="scss">
.block-spacing {
  margin-bottom: 30px;
}
.block-spacing-extended {
  margin-bottom: 100px;
}
.mode-panel {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  opacity: 1;
  padding: 25px;
}
.custom-dropdown >>> .v-select {
  background: #fff;
}
.custom-dropdown >>> .was-Invalidated {
  background-color: #f7d7da;
}

.custom-label {
  font-weight: normal;
  color: #212529;
}
.checkbox-top-spacing {
  margin-top: 25px;
}

.signature-wrapper {
  border-bottom: 2px solid #dee2e6 !important;
}

.custom-radio__extended ::v-deep {
  margin-left: 10px;
  padding-top: 10px;

  .custom-radio-button {
    background-color: #f2f2f2 !important;
    min-width: 70px !important;
    width: auto !important;
    padding: 8px 10px;
  }

  .custom-radio-button.bg-green {
    background-color: #2db782 !important;
  }

  .mobile-div {
    width: auto !important;
  }
}
/* @media screen and (max-width: 768px){
    .mode-panel-container {
      margin-top: 1000px;
    }
  } */
</style>
